import ChatIA from './ChatIA';

export default ChatIA;